import { Outlet } from 'react-router-dom';
import { UserDashboardSideBar } from '../accountProfile/UserDashboardSideBar';

const staySmallSmallProfileData = [
  {
    title: 'Summary',
    link: '/user-dashboard/staySmallSmall/summary',
  },
  {
    title: 'Stay',
    link: '/user-dashboard/staySmallSmall/stay',
  },
  {
    title: 'Favourites',
    link: '/user-dashboard/staySmallSmall/favorites',
  },
  {
    title: 'Recently viewed',
    link: '/user-dashboard/staySmallSmall/recently-viewed',
  },
];

const StaySmallSmallProfile = () => {
  return (
    <>
      <section className="grid grid-cols-1 xl:grid-cols-[18%_80%] mt-8">
        <UserDashboardSideBar sideBarData={staySmallSmallProfileData} />
        <Outlet />
      </section>
    </>
  );
};

export default StaySmallSmallProfile;
